/* MV Sortiment assets/mv-sortiment.konfigurator.js - Agent T-B - 2026-10-02
 *
 * Kauf-Modus-Pakete, Extras, Summe und Warenkorb ohne App fuer die Produktseiten der Theme-Kopie
 * (Impact 6.12.0). Teil von assets/mv-sortiment.js (_build/konkat.sh), laedt allein und in beliebiger
 * Reihenfolge mit den anderen Teilen. Nur Delegation auf document, kein Inline-Skript noetig.
 *
 * Vertrag (Plan P8 "Schnittstellen-Vertrag", snippets/mv-konfigurator-data.liquid von T-C):
 *   Daten-JSON   <script type="application/json" data-mv-konf-data="<formId>"> mit produkt, variant_id,
 *                varianten{<id>:{preis,titel,available}}, pakete[{key,name,empfehlung,verfuegbar,
 *                addons[{handle,variant_id,preis,menge,title,available}]}], vorausgewaehlt,
 *                extras[{handle,variant_id,preis,title,je_automat,nur_bei,nur_mit_paket,available,empfehlung}],
 *                anfrage_extras[{key,name,interesse}], leasing_faktor, mwst, modus ('voll'|'extras_only').
 *                Preise in Cent (wie Shopify variant.price), leasing_faktor in Prozent je Monat (0 = aus).
 *                Toleriert auch code/titel (Metafeld-Schema 4.3) und anfragen statt anfrage_extras.
 *   Eingaben     Wurzel [data-mv-konf="<formId>"]; input[name="mv-paket"][data-mv-paket];
 *                input[name="mv-extra[]"][data-mv-extra]; input[data-mv-anfrage-extra]
 *   Ausgaben     [data-mv-summe-netto], [data-mv-summe-brutto], [data-mv-leasing-rate] (nur Betrag,
 *                "netto"/"brutto" steht im Liquid), [data-mv-positionen] (ul -> li.mv-summe__position),
 *                [data-mv-konf-hinweis]; Oeffner [data-mv-open-anfrage] bekommen data-konfiguration und
 *                data-produkt. Zugehoerigkeit: innerhalb der Wurzel, mit data-mv-konf-form="<formId>",
 *                sonst innerhalb der Shopify-Sektion des Formulars ([data-mv-sticky] auch ausserhalb).
 *   Zustand      window.__mvKonfState[formId] = {variantId, paket, extras:{handle:menge}, anfrage:[], menge}
 *                plus sessionStorage['mv-konf:'+handle]; nach variant:change und product:rerender
 *                (Impact tauscht liquid-Bloecke aus) werden die Eingaben aus dem Zustand zurueckgeschrieben.
 *   Events       mv:konf:change, mv:konf:add (abbrechbar), mv:konf:added (bubbles, auf document);
 *                Analytics konfiguration_change (gedrosselt), konfiguration_warenkorb, konfiguration_fehler.
 *
 * Warenkorb (Impact theme.js ProductForm._onSubmit nachgebildet): Capture-submit auf document nur fuer
 * Formulare mit Daten-JSON -> preventDefault + stopImmediatePropagation -> bei Anfrage-Extra Lightbox
 * statt Warenkorb -> cart:prepare-bundled-sections -> POST cart/add.js mit items[] (Add-ons als
 * verschachtelte Zeilen per parent_id) -> /cart.js -> variant:add am Formular + cart:change am
 * documentElement; bei Fehler cart:error am Formular + cart:refresh.
 *
 * Agent D3-R (2026-10-05): das Modell fuehrt kein Feld zum Preisstatus mehr (Inhaber: Verkaufspreise); das
 * Daten-JSON liefert es nicht mehr, angezeigt wurde es nie.
 *
 * Paket E-1 (2026-10-09): extras[].empfehlung (im Daten-JSON nur als true, sonst fehlt das Feld) steht im Modell als
 * Wahrheitswert empfehlung. Keine Regel, Summe, Sperre oder Ausgabe liest es; den Hinweis an der Karte rendert
 * snippets/mv-konfigurator-extras.liquid (Element mv-checkkarte__empfehlung, nicht [data-mv-extra-hinweis]).
 *
 * Paket A-2b (2026-10-10, _docs/a2b-konto-werkzeuge.md): Die Auswahl speichert ueber das Kundenkonto
 * (assets/mv-sortiment.konto.js, MVKonto) je Produkt unter "konfigurator-<handle>" statt in sessionStorage: Stand
 * { v: 1, titel, variante, optionen, paket, extras, anfrage } (titel = Produkt und Ausfuehrung fuer "Meine Werkzeuge",
 * optionen = gewaehlte Optionswerte aus Impacts Variantenwaehler). Ohne Login im Browser (Spiegel, ueberdauert die
 * Sitzung), mit Login zusaetzlich im Konto. Gespeichert wird nur eine Nutzeraktion (Paket, Extra, Anfrage, Menge,
 * Variante) mit geaendertem Stand, nie der Start. Reihenfolge beim Laden: Server-Markup < gespeicherter Stand < URL
 * (?paket=&extra=); die gespeicherte Ausfuehrung waehlt der Konfigurator ueber Impacts Variantenwaehler
 * (selectCombination), wenn die Adresse kein ?variant= traegt. Ein Altstand aus sessionStorage wird einmalig
 * uebernommen (gespeichert nur, wenn er von der Vorauswahl abweicht) und entfernt. Mit Login zeigt die Kaufbox einen
 * abweichenden Konto-Stand (anderes Geraet, im Konto geloescht), solange auf der Seite nichts gewaehlt wurde; sonst
 * gilt die Seite und geht ins Konto. Statuszeile [data-mv-konto-hinweis] am Ende des Konfigurators (nach jedem
 * Austausch durch Impact neu gebunden). Mit MVKonto wird nur dort gespeichert (Plan, Vertrag Abschnitt 3); ohne MVKonto
 * (Rueckfall) oder bei einem Schluessel ueber 80 Zeichen wie vor A-2b in sessionStorage.
 * konto.js steht im Buendel nach dieser Datei: der Start laeuft wie bei A-2a per Mikrotask nach dem ganzen Buendel.
 *
 * Paket F-4 (2026-10-10, _docs/f4-mindestrate.md; Inhaber 09.10.2026 zur Inhaberfrage 311: "Das gilt fuer
 * Snackautomaten, ist ok wenn andere guenstiger sind."): Die Mindestrate der Partnerbank gilt nur fuer Standautomaten.
 * Das Daten-JSON traegt bei leasing_faktor > 0 die Mindestrate des Geraets in Cent (leasing_mindestrate:
 * snippets/mv-bauform.liquid, Standautomaten 10000, Tischgeraete 0; ohne Feld 0 wie bis F-4); rateAus() hebt eine Rate
 * ueber 0 und darunter auf sie an, wie leasingRate() in assets/mv-sortiment.finvergleich.js.
 *
 * Paket A-9 (2026-10-14, _docs/f7-finder-drei-karten.md; Inhaber: "Das darf nicht bei den Produkten sein"): Auf den
 * Produktseiten steht kein Konto-Hinweis mehr (snippets/mv-konfigurator.liquid rendert snippets/mv-konto-hinweis.liquid
 * nicht mehr). kontoHinweis() bindet nur noch einen Container [data-mv-konto-hinweis] aus dem Markup und baut ohne ihn
 * keine Zeile; Speichern, Lesen und Abgleich ueber MVKonto bleiben unveraendert.
 *
 * Unter Node (Tests) liefert die Datei nur die reinen Rechenfunktionen ueber module.exports.
 * Kommentare ASCII; sichtbare Texte als \u-Escapes, damit die Datei unabhaengig vom Zeichensatz der
 * Auslieferung (text/javascript ohne charset) korrekt ankommt.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-02.1';

  // Sichtbare Texte (Sie-Form). Klartext in Klammern, transliteriert.
  var TEXTE = {
    imPaket: 'Im Paket enthalten',
    nurMitPaket: 'nur mit {pakete} w\u00e4hlbar', // nur mit {pakete} waehlbar
    nurBeiVariante: 'nur bei {varianten} w\u00e4hlbar', // nur bei {varianten} waehlbar
    nichtFuerVariante: 'f\u00fcr diese Ausf\u00fchrung nicht w\u00e4hlbar', // fuer diese Ausfuehrung nicht waehlbar
    nichtVerfuegbar: 'derzeit nicht verf\u00fcgbar', // derzeit nicht verfuegbar
    nurAnfrage: 'Diese Konfiguration ist nur per Angebot m\u00f6glich.', // ... moeglich.
    keineVariante: 'Diese Ausf\u00fchrung ist derzeit nicht bestellbar. Bitte fragen Sie ein Angebot an.',
    paketUnvollstaendig: 'Ein Bestandteil dieser Konfiguration ist derzeit nicht bestellbar. Bitte fragen Sie ein Angebot an.',
    netzwerk: 'Der Warenkorb ist gerade nicht erreichbar. Bitte versuchen Sie es erneut.',
    fehler: 'Die Konfiguration konnte nicht in den Warenkorb gelegt werden. Bitte versuchen Sie es erneut.',
    oder: 'oder',
    keine: 'keine',
    paket: 'Paket',
    extras: 'Extras',
    aufAnfrage: 'Auf Anfrage',
    menge: 'Menge',
    summe: 'Summe',
    netto: 'netto',
    unbekannt: '\u2013'
  };

  var NBSP = '\u00a0';
  var EURO = '\u20ac';
  var PUNKT = ' \u00b7 ';
  var STRICH = ' \u2013 ';

  // ===========================================================================================
  // Reine Logik (ohne DOM; unter Node per module.exports pruefbar)
  // ===========================================================================================

  function text(x) {
    return x === null || x === undefined ? '' : String(x).trim();
  }

  function cent(x) {
    var n = Number(x);
    return isFinite(n) ? Math.round(n) : 0;
  }

  function idText(x) {
    var t = text(x);
    return t && t !== 'null' && t !== 'undefined' ? t : null;
  }

  function numId(x) {
    var n = Number(x);
    return isFinite(n) && n > 0 ? n : null;
  }

  function liste(x) {
    return Array.isArray(x) ? x : [];
  }

  function ganzzahlMin1(x) {
    var n = Math.floor(Number(x));
    return isFinite(n) && n >= 1 ? n : 1;
  }

  function ohneStandardTitel(t) {
    t = text(t);
    return t === 'Default Title' ? '' : t;
  }

  function normalisiereDaten(roh) {
    roh = roh && typeof roh === 'object' ? roh : {};
    var produkt = roh.produkt && typeof roh.produkt === 'object' ? roh.produkt : {};
    var m = {
      version: cent(roh.version) || 1,
      modus: 'pakete',
      produkt: { handle: text(produkt.handle), title: text(produkt.title) },
      variantIdStart: numId(roh.variant_id),
      varianten: {},
      pakete: [],
      vorausgewaehlt: text(roh.vorausgewaehlt) || null,
      extras: [],
      anfrageExtras: [],
      leasingFaktor: Math.max(0, Number(roh.leasing_faktor) || 0),
      // Paket F-4: Mindestrate des Geraets in Cent (nur bei leasing_faktor > 0 im JSON; ohne Feld 0 = keine)
      leasingMindestrate: Math.max(0, cent(roh.leasing_mindestrate)),
      mwst: roh.mwst === null || roh.mwst === undefined || !isFinite(Number(roh.mwst)) ? 19 : Math.max(0, Number(roh.mwst)),
      waehrung: text(roh.waehrung) || 'EUR'
    };

    var varianten = roh.varianten && typeof roh.varianten === 'object' ? roh.varianten : {};
    Object.keys(varianten).forEach(function (k) {
      var v = varianten[k] || {};
      m.varianten[String(k)] = {
        preis: cent(v.preis),
        titel: ohneStandardTitel(v.titel !== undefined ? v.titel : v.title),
        verfuegbar: v.available !== false
      };
    });

    liste(roh.pakete).forEach(function (p) {
      if (!p || typeof p !== 'object') return;
      var key = text(p.key !== undefined ? p.key : p.code);
      if (!key) return;
      var addons = liste(p.addons).filter(function (a) { return a && typeof a === 'object'; }).map(function (a) {
        var vid = idText(a.variant_id);
        return {
          handle: text(a.handle),
          variantId: vid,
          preis: cent(a.preis),
          menge: ganzzahlMin1(a.menge),
          title: text(a.title) || text(a.handle),
          verfuegbar: !!vid && a.available !== false
        };
      });
      m.pakete.push({
        key: key,
        name: text(p.name !== undefined ? p.name : p.titel) || key,
        empfehlung: p.empfehlung === true,
        verfuegbar: p.verfuegbar !== false && addons.every(function (a) { return a.verfuegbar; }),
        addons: addons
      });
    });

    liste(roh.extras).forEach(function (e) {
      if (!e || typeof e !== 'object') return;
      var handle = text(e.handle);
      if (!handle) return;
      var vid = idText(e.variant_id);
      m.extras.push({
        handle: handle,
        variantId: vid,
        preis: cent(e.preis),
        title: text(e.title) || handle,
        jeAutomat: ganzzahlMin1(e.je_automat),
        nurBei: liste(e.nur_bei).map(idText).filter(Boolean),
        nurMitPaket: liste(e.nur_mit_paket).map(text).filter(Boolean),
        verfuegbar: !!vid && e.available !== false,
        empfehlung: !!e.empfehlung
      });
    });

    liste(roh.anfrage_extras !== undefined ? roh.anfrage_extras : roh.anfragen).forEach(function (a) {
      if (!a || typeof a !== 'object') return;
      var key = text(a.key);
      if (!key) return;
      m.anfrageExtras.push({ key: key, name: text(a.name !== undefined ? a.name : a.titel) || key, interesse: text(a.interesse) });
    });

    if (text(roh.modus) === 'extras_only' || !m.pakete.length) m.modus = 'extras_only';
    return m;
  }

  function findePaket(m, key) {
    if (!key || m.modus === 'extras_only') return null;
    for (var i = 0; i < m.pakete.length; i++) if (m.pakete[i].key === key) return m.pakete[i];
    return null;
  }

  function findeExtra(m, handle) {
    for (var i = 0; i < m.extras.length; i++) if (m.extras[i].handle === handle) return m.extras[i];
    return null;
  }

  function findeAnfrage(m, key) {
    for (var i = 0; i < m.anfrageExtras.length; i++) if (m.anfrageExtras[i].key === key) return m.anfrageExtras[i];
    return null;
  }

  function standardPaket(m) {
    if (m.modus === 'extras_only' || !m.pakete.length) return null;
    var kandidaten = [findePaket(m, m.vorausgewaehlt)];
    m.pakete.forEach(function (p) { if (p.empfehlung) kandidaten.push(p); });
    kandidaten = kandidaten.concat(m.pakete);
    for (var i = 0; i < kandidaten.length; i++) if (kandidaten[i] && kandidaten[i].verfuegbar) return kandidaten[i].key;
    return m.pakete[0].key;
  }

  function ersteVariante(m) {
    var keys = Object.keys(m.varianten);
    return keys.length ? numId(keys[0]) : null;
  }

  function variantenTitel(m, variantId) {
    var v = m.varianten[String(variantId)];
    return v ? v.titel : '';
  }

  // "A", "A" oder "B", "A", "B" oder "C"
  function aufzaehlung(namen, zitiert) {
    var t = namen.map(function (n) { return zitiert ? '\u201e' + n + '\u201c' : n; });
    if (t.length <= 1) return t.join('');
    return t.slice(0, -1).join(', ') + ' ' + TEXTE.oder + ' ' + t[t.length - 1];
  }

  // Sperrlogik je Extra: frei | im-paket | nicht-verfuegbar | variante | nur-mit-paket
  function regeln(m, z) {
    var paket = findePaket(m, z && z.paket);
    var vid = z && z.variantId !== null && z.variantId !== undefined ? String(z.variantId) : '';
    var r = {};
    m.extras.forEach(function (e) {
      var status = 'frei';
      var hinweis = '';
      var imPaket = !!paket && paket.addons.some(function (a) {
        return a.handle === e.handle || (!!a.variantId && a.variantId === e.variantId);
      });
      if (imPaket) {
        status = 'im-paket';
        hinweis = TEXTE.imPaket;
      } else if (!e.verfuegbar) {
        status = 'nicht-verfuegbar';
        hinweis = TEXTE.nichtVerfuegbar;
      } else if (e.nurBei.length && e.nurBei.indexOf(vid) === -1) {
        status = 'variante';
        var titel = e.nurBei.map(function (id) { return variantenTitel(m, id); }).filter(Boolean);
        hinweis = titel.length ? TEXTE.nurBeiVariante.replace('{varianten}', aufzaehlung(titel, false)) : TEXTE.nichtFuerVariante;
      } else if (e.nurMitPaket.length && !(paket && e.nurMitPaket.indexOf(paket.key) !== -1)) {
        status = 'nur-mit-paket';
        var namen = e.nurMitPaket.map(function (k) {
          var p = findePaket(m, k);
          return p ? p.name : k;
        });
        hinweis = TEXTE.nurMitPaket.replace('{pakete}', aufzaehlung(namen, true));
      }
      r[e.handle] = { status: status, hinweis: hinweis };
    });
    return r;
  }

  // Liefert einen neuen, gueltigen Zustand: Paket vorhanden und bestellbar, nur freie Extras
  // (Menge = je_automat aus den Daten), nur bekannte Anfrage-Extras, Menge >= 1.
  function bereinige(m, z) {
    z = z || {};
    var neu = { variantId: numId(z.variantId), paket: null, extras: {}, anfrage: [], menge: ganzzahlMin1(z.menge) };
    if (m.modus !== 'extras_only') {
      var p = findePaket(m, text(z.paket));
      neu.paket = p && p.verfuegbar ? p.key : standardPaket(m);
    }
    var r = regeln(m, neu);
    var gewaehlt = z.extras && typeof z.extras === 'object' ? z.extras : {};
    m.extras.forEach(function (e) {
      if (gewaehlt[e.handle] && r[e.handle] && r[e.handle].status === 'frei') neu.extras[e.handle] = e.jeAutomat;
    });
    liste(z.anfrage).forEach(function (k) {
      k = text(k);
      if (findeAnfrage(m, k) && neu.anfrage.indexOf(k) === -1) neu.anfrage.push(k);
    });
    return neu;
  }

  function startZustand(m, vorgaben) {
    vorgaben = vorgaben || {};
    var vid = vorgaben.variantId !== null && vorgaben.variantId !== undefined ? vorgaben.variantId : (m.variantIdStart || ersteVariante(m));
    return bereinige(m, {
      variantId: vid,
      paket: text(vorgaben.paket) || standardPaket(m),
      extras: vorgaben.extras,
      anfrage: vorgaben.anfrage,
      menge: vorgaben.menge
    });
  }

  function freieExtras(m, z) {
    var r = regeln(m, z);
    return m.extras.filter(function (e) {
      return !!(z.extras && z.extras[e.handle]) && r[e.handle].status === 'frei';
    });
  }

  // Kaufmaennisch runden (halbe Einheit weg von null), ganzzahlig: zaehler / nenner
  function rundeKaufmaennisch(zaehler, nenner) {
    if (zaehler < 0) return -rundeKaufmaennisch(-zaehler, nenner);
    return Math.floor((2 * zaehler + nenner) / (2 * nenner));
  }

  function bruttoAus(netto, mwst) {
    var satz = Math.round((mwst === null || mwst === undefined ? 19 : Number(mwst)) * 100); // 19 % -> 1900
    return rundeKaufmaennisch(cent(netto) * (10000 + satz), 10000);
  }

  // Leasingrate je Monat in Cent; faktor in Prozent (1,85 -> 1,85 % der Nettosumme), 0 = aus. Paket F-4: mindestCent =
  // Mindestrate des Geraets (Standautomaten 10000, Tischgeraete 0); eine Rate ueber 0 und darunter gilt als Mindestrate
  // Paket F-5 (2026-11-03, _docs/f5-mindestrate.md): keine Mindestrate der Partnerbank - snippets/mv-konfigurator-data.liquid
  // liefert leasing_mindestrate immer 0, rateAus() rechnet damit Summe x Faktor (Logik unveraendert)
  function rateAus(netto, faktorProzent, mindestCent) {
    var f = Number(faktorProzent);
    if (!isFinite(f) || f <= 0) return null;
    var rate = rundeKaufmaennisch(cent(netto) * Math.round(f * 10000), 1000000);
    var min = Math.max(0, cent(mindestCent));
    return rate > 0 && rate < min ? min : rate;
  }

  var formate = {};

  function zifferngruppen(c, stellen) {
    var euro = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (!stellen) return euro;
    var rest = c % 100;
    return euro + ',' + (rest < 10 ? '0' : '') + rest;
  }

  function zahlFormat(stellen) {
    if (formate.hasOwnProperty(stellen)) return formate[stellen];
    var f = null;
    try {
      f = new Intl.NumberFormat('de-DE', { minimumFractionDigits: stellen, maximumFractionDigits: stellen });
      // Selbsttest: ohne volle ICU-Daten faellt Intl still auf en zurueck
      if (f.format(1234.5) !== (stellen ? '1.234,50' : '1.235')) f = null;
    } catch (e) {
      f = null;
    }
    formate[stellen] = f;
    return f;
  }

  // Geldformat de-DE. Netto: ganze Euro ohne Nachkommastellen (6.470 EUR), sonst zwei (89,90 EUR).
  // mitCent = true: immer zwei Stellen (Brutto, Entscheid 02.10. wie mv-preis und X10-Texte: 7.021,00 EUR)
  function formatGeld(betragCent, mitCent) {
    var c = cent(betragCent);
    var negativ = c < 0;
    if (negativ) c = -c;
    var stellen = mitCent === true || c % 100 !== 0 ? 2 : 0;
    var f = zahlFormat(stellen);
    return (negativ ? '-' : '') + (f ? f.format(c / 100) : zifferngruppen(c, stellen)) + NBSP + EURO;
  }

  function formatBrutto(betragCent) {
    return formatGeld(betragCent, true);
  }

  function produktText(m, z) {
    var vt = variantenTitel(m, z && z.variantId);
    return vt ? m.produkt.title + STRICH + vt : m.produkt.title;
  }

  function summe(m, z) {
    var v = m.varianten[String(z.variantId)];
    var menge = ganzzahlMin1(z.menge);
    var automat = v ? v.preis : 0;
    var positionen = [{ art: 'automat', handle: m.produkt.handle, titel: produktText(m, z), menge: menge, einzel: automat, gesamt: automat * menge }];
    var paketSumme = 0;
    var paket = findePaket(m, z.paket);
    if (paket) {
      paket.addons.forEach(function (a) {
        paketSumme += a.preis * a.menge;
        positionen.push({ art: 'paket', handle: a.handle, titel: paket.name + ': ' + a.title, menge: a.menge * menge, einzel: a.preis, gesamt: a.preis * a.menge * menge });
      });
    }
    var extraSumme = 0;
    freieExtras(m, z).forEach(function (e) {
      var anzahl = z.extras[e.handle];
      extraSumme += e.preis * anzahl;
      positionen.push({ art: 'extra', handle: e.handle, titel: e.title, menge: anzahl * menge, einzel: e.preis, gesamt: e.preis * anzahl * menge });
    });
    var proAutomat = automat + paketSumme + extraSumme;
    var netto = proAutomat * menge;
    return {
      vollstaendig: !!v,
      automat: automat,
      paketSumme: paketSumme,
      extraSumme: extraSumme,
      proAutomat: proAutomat,
      menge: menge,
      netto: netto,
      brutto: bruttoAus(netto, m.mwst),
      leasing: rateAus(netto, m.leasingFaktor, m.leasingMindestrate),
      positionen: positionen
    };
  }

  // Text fuer Lightbox (contact[Konfiguration]) und data-konfiguration der Oeffner
  function konfigurationsText(m, z, s) {
    var teile = [];
    var paket = findePaket(m, z.paket);
    if (paket) teile.push(TEXTE.paket + ': ' + paket.name);
    var extras = freieExtras(m, z).map(function (e) { return e.title; });
    teile.push(TEXTE.extras + ': ' + (extras.length ? extras.join(', ') : TEXTE.keine));
    var anfragen = liste(z.anfrage).map(function (k) {
      var a = findeAnfrage(m, k);
      return a ? a.name : k;
    });
    if (anfragen.length) teile.push(TEXTE.aufAnfrage + ': ' + anfragen.join(', '));
    if (z.menge > 1) teile.push(TEXTE.menge + ': ' + z.menge);
    if (s && s.vollstaendig) teile.push(TEXTE.summe + ' ' + formatGeld(s.netto) + ' ' + TEXTE.netto);
    return teile.join(PUNKT);
  }

  // Sichtbare Line-Item-Property "Konfiguration" am Automaten (Checkout, Bestellung, Admin)
  function warenkorbKonfiguration(m, z) {
    var teile = [];
    var vt = variantenTitel(m, z.variantId);
    if (vt) teile.push(vt);
    var paket = findePaket(m, z.paket);
    if (paket) teile.push(paket.name);
    freieExtras(m, z).forEach(function (e) { teile.push(e.title); });
    return teile.join(PUNKT);
  }

  // Leerer String = bestellbar, sonst Meldung fuer cart:error
  function pruefeBestellbar(m, z) {
    var vid = numId(z && z.variantId);
    if (!vid) return TEXTE.keineVariante;
    var v = m.varianten[String(vid)];
    if (v && v.verfuegbar === false) return TEXTE.keineVariante;
    var paket = findePaket(m, z.paket);
    if (paket && (!paket.verfuegbar || paket.addons.some(function (a) { return !numId(a.variantId); }))) return TEXTE.paketUnvollstaendig;
    var r = regeln(m, z);
    var gesperrt = Object.keys(z.extras || {}).some(function (h) { return !r[h] || r[h].status !== 'frei'; });
    return gesperrt ? TEXTE.paketUnvollstaendig : '';
  }

  // items[] fuer POST cart/add.js: Automat + Add-ons als verschachtelte Zeilen (parent_id).
  // Ohne Add-ons kein _konfig/Konfiguration: gleiche Konfigurationen landen dann wie bei Impacts
  // normalem Add in derselben Zeile (Menge addiert statt neuer Zeile).
  function baueItems(m, z, konfigId) {
    var vid = numId(z.variantId);
    var menge = ganzzahlMin1(z.menge);
    var paket = findePaket(m, z.paket);
    var kinder = [];
    function dazu(variantId, anzahl, handle) {
      var id = numId(variantId);
      if (!id || id === vid) return;
      for (var i = 0; i < kinder.length; i++) {
        if (kinder[i].id === id) {
          kinder[i].je += anzahl;
          return;
        }
      }
      kinder.push({ id: id, je: anzahl, handle: handle });
    }
    if (paket) paket.addons.forEach(function (a) { dazu(a.variantId, a.menge, a.handle); });
    freieExtras(m, z).forEach(function (e) { dazu(e.variantId, z.extras[e.handle], e.handle); });

    var eigenschaften = {};
    if (kinder.length) eigenschaften._konfig = konfigId;
    if (paket) {
      eigenschaften._paket = paket.key;
      eigenschaften.Paket = paket.name;
    }
    if (kinder.length) eigenschaften.Konfiguration = warenkorbKonfiguration(m, z);
    var automat = { id: vid, quantity: menge };
    if (Object.keys(eigenschaften).length) automat.properties = eigenschaften;

    var fuer = produktText(m, z);
    var items = [automat];
    kinder.forEach(function (k) {
      var p = { _konfig: konfigId, _zu: m.produkt.handle, _je_automat: String(k.je) };
      p['F\u00fcr'] = fuer; // Property "Fuer" (sichtbar in Warenkorb, Checkout, Bestellung)
      items.push({ id: k.id, quantity: k.je * menge, parent_id: vid, properties: p });
    });
    return items;
  }

  function baueWarenkorbBody(m, z, konfigId, sections, wurzel) {
    var items = baueItems(m, z, konfigId);
    return {
      items: items,
      sections: liste(sections).join(','),
      sections_url: (wurzel || '/') + 'variants/' + items[0].id
    };
  }

  // URL-Vorauswahl der Paketkarten (Startseite, T-G) und des Finders (T-F):
  // ?variant=<id>&paket=<code>&extra=<handle>,<handle>#mv-konfigurator -> { paket, extras: [handles] }
  // extra darf mehrfach vorkommen; leeres extra= heisst ausdruecklich "keine Extras".
  function urlVorgaben(suche) {
    var ergebnis = {};
    var s = text(suche);
    if (s.charAt(0) === '?') s = s.slice(1);
    s.split('&').forEach(function (teil) {
      if (!teil) return;
      var i = teil.indexOf('=');
      var name;
      var wert;
      try {
        name = decodeURIComponent((i === -1 ? teil : teil.slice(0, i)).replace(/\+/g, ' '));
        wert = decodeURIComponent((i === -1 ? '' : teil.slice(i + 1)).replace(/\+/g, ' '));
      } catch (e) {
        return;
      }
      if (name === 'paket' && text(wert) && ergebnis.paket === undefined) ergebnis.paket = text(wert);
      if (name === 'extra') {
        ergebnis.extras = ergebnis.extras || [];
        wert.split(',').map(text).filter(Boolean).forEach(function (h) {
          if (ergebnis.extras.indexOf(h) === -1) ergebnis.extras.push(h);
        });
      }
    });
    return ergebnis;
  }

  function analyseDaten(m, z, s) {
    return {
      produkt: m.produkt.handle,
      variante: z.variantId ? String(z.variantId) : '',
      paket: z.paket || '',
      extras: freieExtras(m, z).map(function (e) { return e.handle; }).join(','),
      anfrage: liste(z.anfrage).join(','),
      menge: z.menge,
      summe_netto: s.netto / 100,
      waehrung: m.waehrung || 'EUR'
    };
  }

  // ---- Kundenkonto (Paket A-2b) -----------------------------------------------------------------

  var KONTO_PRAEFIX = 'konfigurator-';
  var KONTO_RE = /^[a-z0-9-]{2,80}$/;   // Vertrag Abschnitt 3 (wie SCHLUESSEL_RE in konto.js)
  var TITEL_MAX = 80;

  // Werkzeug-Schluessel je Produkt oder null (Handle passt nicht in den Vertrag: dann wie vor A-2b sessionStorage)
  function kontoWerkzeug(handle) {
    var w = KONTO_PRAEFIX + text(handle);
    return text(handle) && KONTO_RE.test(w) ? w : null;
  }

  function kurzTitel(t) {
    var s = text(t).replace(/\s+/g, ' ');
    return s.length > TITEL_MAX ? s.slice(0, TITEL_MAX - 1).replace(/\s+$/, '') + '\u2026' : s;
  }

  // Stand { v: 1, titel, variante, optionen, paket, extras, anfrage }; extras = freie Extras in der Reihenfolge der Daten
  function kontoStand(m, z, optionen) {
    var s = {
      v: 1,
      titel: kurzTitel(produktText(m, z)),
      variante: numId(z && z.variantId),
      optionen: liste(optionen).map(text).filter(function (x) { return /^\d{1,20}$/.test(x); }),
      paket: z && z.paket ? text(z.paket) : null,
      extras: freieExtras(m, z || {}).map(function (e) { return e.handle; }),
      anfrage: liste(z && z.anfrage).map(text).filter(Boolean)
    };
    if (!s.titel) delete s.titel;
    return s;
  }

  // Stand aus Konto, Spiegel oder Altspeicher -> Vorgaben { variante, optionen, paket, extras: {handle: 1}, anfrage } oder
  // null; unbekannte Pakete und Extras raeumt danach bereinige() weg
  function kontoVorgaben(stand) {
    if (!stand || typeof stand !== 'object' || Array.isArray(stand) || stand.v !== 1) return null;
    var v = { variante: numId(stand.variante), optionen: [], paket: text(stand.paket) || null, extras: {}, anfrage: [] };
    liste(stand.optionen).forEach(function (o) { if (/^\d{1,20}$/.test(text(o))) v.optionen.push(text(o)); });
    // Altstand (sessionStorage): extras als {handle: menge}; Stand: Liste der Handles
    if (Array.isArray(stand.extras)) stand.extras.forEach(function (h) { if (text(h)) v.extras[text(h)] = 1; });
    else if (stand.extras && typeof stand.extras === 'object') Object.keys(stand.extras).forEach(function (h) { if (stand.extras[h]) v.extras[h] = 1; });
    liste(stand.anfrage).forEach(function (k) { if (text(k) && v.anfrage.indexOf(text(k)) === -1) v.anfrage.push(text(k)); });
    return v;
  }

  var logik = {
    VERSION: VERSION,
    TEXTE: TEXTE,
    KONTO_PRAEFIX: KONTO_PRAEFIX,
    kontoWerkzeug: kontoWerkzeug,
    kontoStand: kontoStand,
    kontoVorgaben: kontoVorgaben,
    normalisiereDaten: normalisiereDaten,
    startZustand: startZustand,
    bereinige: bereinige,
    regeln: regeln,
    summe: summe,
    formatGeld: formatGeld,
    formatBrutto: formatBrutto,
    rundeKaufmaennisch: rundeKaufmaennisch,
    bruttoAus: bruttoAus,
    rateAus: rateAus,
    konfigurationsText: konfigurationsText,
    warenkorbKonfiguration: warenkorbKonfiguration,
    produktText: produktText,
    baueItems: baueItems,
    baueWarenkorbBody: baueWarenkorbBody,
    pruefeBestellbar: pruefeBestellbar,
    urlVorgaben: urlVorgaben,
    analyseDaten: analyseDaten
  };

  // Exportfenster nur unter Node (kein window): Tests laden die Datei als Skript mit module-Objekt
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logik;
    return;
  }

  // ===========================================================================================
  // Browser
  // ===========================================================================================

  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (MV.konfigurator) return;

  var ANALYSE_MS = 2000;
  var NUTZERGRUND = { paket: 1, extra: 1, anfrage: 1, menge: 1, variante: 1 };

  var modelle = {};   // formId -> { modell, quelle }
  var bereit = {};    // formId -> true nach erster Initialisierung
  var laufend = {};   // formId -> true waehrend cart/add.js (Doppel-Submit-Sperre)
  var geplant = {};   // formId -> true: Abgleich nach product:rerender eingeplant
  var analyseTimer = {};
  var analyseZuletzt = {};
  var hinweisZaehler = 0;
  var konten = {};    // formId -> Kundenkonto (A-2b): { mv, werkzeug, text, geaendert, vorgaben, ausUrl, box, variante }

  function zustaende() {
    if (!window.__mvKonfState || typeof window.__mvKonfState !== 'object') window.__mvKonfState = {};
    return window.__mvKonfState;
  }

  function alsListe(sammlung) {
    return Array.prototype.slice.call(sammlung || []);
  }

  function attr(name, wert) {
    return '[' + name + '="' + String(wert).replace(/["\\]/g, '\\$&') + '"]';
  }

  function routenWurzel() {
    var s = window.Shopify;
    return (s && s.routes && s.routes.root) || '/';
  }

  function themeEinstellungen() {
    var t = window.themeVariables;
    return (t && t.settings) || {};
  }

  function warne(meldung) {
    try {
      if (window.console && window.console.warn) window.console.warn('[mv-sortiment] ' + meldung);
    } catch (e) { /* nie stoeren */ }
  }

  function publish(name, daten) {
    try {
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') a.publish(name, daten);
    } catch (e) { /* Analytics darf den Ablauf nie stoeren */ }
  }

  function sende(ziel, name, detail, abbrechbar) {
    return ziel.dispatchEvent(new CustomEvent(name, { bubbles: true, cancelable: !!abbrechbar, detail: detail }));
  }

  function kopie(z) {
    return JSON.parse(JSON.stringify(z));
  }

  function maskiere(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formular(formId) {
    var f = formId ? document.getElementById(formId) : null;
    return f && f.tagName === 'FORM' ? f : null;
  }

  function datenSkript(formId) {
    return document.querySelector('script' + attr('data-mv-konf-data', formId));
  }

  function hatDaten(formId) {
    return !!formId && (!!modelle[formId] || !!datenSkript(formId));
  }

  function wurzeln(formId) {
    return alsListe(document.querySelectorAll(attr('data-mv-konf', formId)));
  }

  // Formular-ID eines Elements aus Wurzel oder ausdruecklicher Zuordnung
  function formIdVon(el) {
    if (!el || !el.closest) return null;
    var w = el.closest('[data-mv-konf]');
    if (w && w.getAttribute('data-mv-konf')) return w.getAttribute('data-mv-konf');
    var l = el.closest('[data-mv-konf-form]');
    if (l && l.getAttribute('data-mv-konf-form')) return l.getAttribute('data-mv-konf-form');
    return null;
  }

  function sektionVon(formId) {
    var f = formular(formId);
    return f && f.closest ? f.closest('.shopify-section') : null;
  }

  function einzigerKonfigurator() {
    var ids = Object.keys(modelle);
    return ids.length === 1 ? ids[0] : null;
  }

  // eigenesAttribut: Ausgaben wie [data-mv-summe-netto="<formId>"] tragen die Zuordnung selbst
  function gehoertZu(el, formId, eigenesAttribut) {
    var eigen = eigenesAttribut ? el.getAttribute(eigenesAttribut) : '';
    if (eigen) return eigen === formId;
    var id = formIdVon(el);
    if (id) return id === formId;
    var sticky = el.closest ? el.closest('[data-mv-sticky]') : null;
    if (sticky && sticky.getAttribute('data-mv-sticky')) return sticky.getAttribute('data-mv-sticky') === formId;
    var sektion = sektionVon(formId);
    if (!sektion) return true;
    if (sektion.contains(el)) return true;
    return !!sticky && einzigerKonfigurator() === formId;
  }

  function alle(selektor, formId, eigenesAttribut) {
    return alsListe(document.querySelectorAll(selektor)).filter(function (el) { return gehoertZu(el, formId, eigenesAttribut); });
  }

  function ladeModell(formId) {
    var skript = datenSkript(formId);
    var alt = modelle[formId];
    if (!skript) return alt ? alt.modell : null;
    var quelle = skript.textContent || '';
    if (alt && alt.quelle === quelle) return alt.modell;
    var roh;
    try {
      roh = JSON.parse(quelle);
    } catch (e) {
      warne('Daten-JSON fuer ' + formId + ' nicht lesbar');
      return alt ? alt.modell : null;
    }
    var modell = normalisiereDaten(roh);
    if (alt) {
      // aus variant:change gelernte Variantenpreise behalten
      Object.keys(alt.modell.varianten).forEach(function (k) {
        if (!modell.varianten[k]) modell.varianten[k] = alt.modell.varianten[k];
      });
    }
    var w = wurzeln(formId)[0];
    if (w && w.getAttribute('data-mv-konf-modus') === 'extras_only') modell.modus = 'extras_only';
    modelle[formId] = { modell: modell, quelle: quelle };
    return modell;
  }

  function variantIdAusDom(formId) {
    var f = formular(formId);
    var el = (f && f.querySelector('[name="id"]')) || document.querySelector('[name="id"]' + attr('form', formId));
    return el ? numId(el.value) : null;
  }

  function mengeAusDom(formId) {
    var el = document.querySelector('input[name="quantity"]' + attr('form', formId));
    if (!el) {
      var f = formular(formId);
      el = f && f.querySelector('input[name="quantity"]');
    }
    return el ? ganzzahlMin1(parseInt(el.value, 10)) : 1;
  }

  function speicherSchluessel(m, formId) {
    return 'mv-konf:' + (m.produkt.handle || formId);
  }

  function speichere(m, z, formId) {
    try {
      window.sessionStorage.setItem(speicherSchluessel(m, formId), JSON.stringify({
        v: 1, variantId: z.variantId, paket: z.paket, extras: z.extras, anfrage: z.anfrage, menge: z.menge
      }));
    } catch (e) { /* privater Modus, Speicher voll */ }
  }

  function ladeGespeichert(m, formId) {
    try {
      var t = window.sessionStorage.getItem(speicherSchluessel(m, formId));
      var w = t ? JSON.parse(t) : null;
      return w && typeof w === 'object' ? w : null;
    } catch (e) {
      return null;
    }
  }

  function wertVon(el, attributName) {
    return el.getAttribute(attributName) || el.value || '';
  }

  // Startauswahl aus dem Server-Markup (Liquid setzt checked)
  function ausDom(formId, m) {
    var v = { variantId: variantIdAusDom(formId) || m.variantIdStart, menge: mengeAusDom(formId), paket: null, extras: {}, anfrage: [] };
    alle('input[name="mv-paket"]', formId).forEach(function (el) {
      if (el.checked && !v.paket) v.paket = wertVon(el, 'data-mv-paket');
    });
    alle('input[name="mv-extra[]"]', formId).forEach(function (el) {
      if (el.checked && !el.disabled) v.extras[wertVon(el, 'data-mv-extra')] = 1;
    });
    alle('input[data-mv-anfrage-extra]', formId).forEach(function (el) {
      if (el.checked) v.anfrage.push(wertVon(el, 'data-mv-anfrage-extra'));
    });
    return v;
  }

  function initFormular(formId) {
    if (!formId) return null;
    var m = ladeModell(formId);
    if (!m) return null;
    var st = zustaende();
    if (!bereit[formId]) {
      bereit[formId] = true;
      if (!st[formId] || typeof st[formId] !== 'object') {
        // Reihenfolge: Server-Markup < gespeicherter Stand (A-2b: MVKonto statt sessionStorage) < URL (?paket=&extra=)
        var vorgaben = ausDom(formId, m);
        var k = kontoBeginn(formId, m, vorgaben);
        var gespeichert = k ? k.vorgaben : ladeGespeichert(m, formId);
        if (gespeichert) {
          if (gespeichert.paket) vorgaben.paket = gespeichert.paket;
          if (gespeichert.extras && typeof gespeichert.extras === 'object') vorgaben.extras = gespeichert.extras;
          if (Array.isArray(gespeichert.anfrage)) vorgaben.anfrage = gespeichert.anfrage;
        }
        var ausUrl = urlVorgaben(window.location.search);
        if (ausUrl.paket) vorgaben.paket = ausUrl.paket;
        if (ausUrl.extras) {
          vorgaben.extras = {};
          ausUrl.extras.forEach(function (h) { vorgaben.extras[h] = 1; });
        }
        if (k) k.ausUrl = !!(ausUrl.paket || ausUrl.extras);
        st[formId] = startZustand(m, vorgaben);
      }
      aktualisiere(formId, 'init');
      kontoStart(formId, m);
    }
    return st[formId];
  }

  // ---- Kundenkonto (Paket A-2b) -----------------------------------------------------------------

  // MVKonto (assets/mv-sortiment.konto.js) steht im Buendel nach dieser Datei: erst beim Aufruf aufloesen. Mit MVKonto
  // speichert der Konfigurator nur dort (der Altspeicher sessionStorage wird einmalig gelesen und entfernt); ohne MVKonto
  // (Rueckfall, etwa beim Rueckweg von A-2a) oder bei einem Schluessel ueber 80 Zeichen wie vor A-2b in sessionStorage.
  function kontoApi() {
    var k = window.MVKonto;
    return k && typeof k.lokal === 'function' && typeof k.speichern === 'function' && typeof k.lesen === 'function' &&
      typeof k.loeschen === 'function' ? k : null;
  }

  // Start erst nach dem ganzen Buendel (konto.js steht dahinter): Mikrotask, laeuft vor dem naechsten Zeichnen
  function nachBuendel(fn) {
    if (window.MVKonto || typeof window.Promise !== 'function') fn();
    else window.Promise.resolve().then(fn);
  }

  // gewaehlte Optionswerte aus Impacts Variantenwaehler (input[data-option-position]:checked, Wert = Optionswert-ID)
  function optionenAusDom(formId) {
    var f = formular(formId);
    var felder = f && f.elements ? alsListe(f.elements) : alsListe(document.querySelectorAll('input[data-option-position]' + attr('form', formId)));
    return felder.filter(function (el) {
      return el.matches && el.matches('input[data-option-position]:checked');
    }).sort(function (a, b) {
      return (parseInt(a.getAttribute('data-option-position'), 10) || 0) - (parseInt(b.getAttribute('data-option-position'), 10) || 0);
    }).map(function (el) { return el.value; });
  }

  // Vorgaben aus dem Spiegel (sonst einmalig aus dem Altstand in sessionStorage); null = ohne MVKonto (sessionStorage)
  function kontoBeginn(formId, m, startVorgaben) {
    var mv = kontoApi();
    var w = mv ? kontoWerkzeug(m.produkt.handle) : null;
    if (!w) return null;
    var k = { mv: mv, werkzeug: w, text: null, geaendert: false, vorgaben: null, ausUrl: false, box: null, variante: null, alt: null };
    konten[formId] = k;
    var e = mv.lokal(w);
    k.vorgaben = e ? kontoVorgaben(e.stand) : null;
    var alt = ladeGespeichert(m, formId);
    if (alt) {
      try {
        window.sessionStorage.removeItem(speicherSchluessel(m, formId));
      } catch (f) { /* ohne Speicher nichts aufzuraeumen */ }
      if (!k.vorgaben) {
        var v = kontoVorgaben({ v: 1, paket: alt.paket, extras: alt.extras, anfrage: alt.anfrage });
        // nur eine echte Wahl (abweichend von der Vorauswahl der Seite) wird gespeichert, sobald der Stand steht
        var a = bereinige(m, { variantId: startVorgaben.variantId, paket: v.paket || startVorgaben.paket, extras: v.extras, anfrage: v.anfrage });
        var b = bereinige(m, startVorgaben);
        if (a.paket !== b.paket || JSON.stringify(a.extras) !== JSON.stringify(b.extras) || JSON.stringify(a.anfrage) !== JSON.stringify(b.anfrage)) k.alt = true;
        k.vorgaben = v;
      }
    }
    return k;
  }

  // Nach dem ersten Zeichnen: Stand merken, Statuszeile binden, gespeicherte Ausfuehrung waehlen, mit Login abgleichen
  function kontoStart(formId, m) {
    var k = konten[formId];
    if (!k) return;
    var z = zustaende()[formId];
    // Altstand mit echter Wahl einmalig speichern - nur wenn die Seite ihn zeigt (eine Vorauswahl aus der Adresse gilt)
    if (k.alt && !k.ausUrl) {
      k.alt = null;
      k.geaendert = true;
      kontoSpeichern(formId, m, z, 'alt');
    } else k.text = JSON.stringify(kontoStand(m, z, optionenAusDom(formId)));
    kontoHinweis(formId);
    if (k.vorgaben && !k.ausUrl) kontoVariante(formId, m, k.vorgaben);
    if (typeof k.mv.eingeloggt !== 'function' || !k.mv.eingeloggt()) return;
    k.mv.lesen(k.werkzeug).then(function (r) { kontoAbgleich(formId, r); }, function () { /* Konto nicht erreichbar: Browser-Stand gilt */ });
  }

  // Statuszeile im Konfigurator (snippets/mv-konfigurator.liquid); Impact tauscht den Block beim Variantenwechsel aus
  function kontoHinweis(formId) {
    var k = konten[formId];
    if (!k || typeof k.mv.hinweis !== 'function') return;
    var box = null;
    var liste = wurzeln(formId);
    liste.forEach(function (w) {
      if (!box) box = w.querySelector('[data-mv-konto-hinweis]');
    });
    if (box && box === k.box) return;
    // A-9: nur ein Container aus dem Markup wird gebunden; ohne ihn (Produktseiten seit A-9) keine Zeile - Speichern,
    // Lesen und Abgleich laufen unabhaengig davon (kontoSpeichern, kontoAbgleich)
    if (box) k.box = k.mv.hinweis(box, k.werkzeug) || box;
  }

  // Gespeicherte Ausfuehrung ueber Impacts Variantenwaehler waehlen (wie ein Klick: Impact laedt die Kaufbox der
  // Kombination, wirft product:rerender und variant:change). Nur ohne ?variant= in der Adresse, nur bekannte und
  // verfuegbare Varianten, nur Optionswerte dieses Produkts (kein Link auf ein anderes Produkt).
  function kontoVariante(formId, m, v) {
    var k = konten[formId];
    var z = zustaende()[formId];
    if (!k || !z || !v || !v.variante || !v.optionen.length || String(v.variante) === String(z.variantId)) return;
    if (/[?&]variant=/.test(window.location.search)) return;
    var ziel = m.varianten[String(v.variante)];
    if (!ziel || ziel.verfuegbar === false) return;
    var f = formular(formId);
    var felder = f && f.elements ? alsListe(f.elements) : [];
    var ok = v.optionen.every(function (id) {
      var el = felder.filter(function (x) { return x.matches && x.matches('input[data-option-position]') && x.value === id; })[0];
      return !!el && !el.hasAttribute('data-product-url');
    });
    var waehler = document.querySelector('variant-picker' + attr('form-id', formId));
    if (!ok || !waehler || !window.customElements || typeof window.customElements.whenDefined !== 'function') return;
    k.variante = String(v.variante);
    window.customElements.whenDefined('variant-picker').then(function () {
      if (k.variante !== String(v.variante) || k.geaendert || typeof waehler.selectCombination !== 'function') {
        k.variante = null;
        return;
      }
      try {
        window.Promise.resolve(waehler.selectCombination({ optionValues: v.optionen.slice(), productChange: false }))['catch'](function () { k.variante = null; });
      } catch (e) {
        k.variante = null;
      }
    });
  }

  // Antwort des Kontos: abweichender Stand (anderes Geraet) oder im Konto geloescht. Auf der Seite schon gewaehlt: die
  // Seite gilt und geht wieder ins Konto (auch bei nachgehender Geraeteuhr). Vorauswahl aus der Adresse: sie gilt. Sonst
  // zeigt die Kaufbox den Konto-Stand (im Konto geloescht: die Vorauswahl der Seite).
  function kontoAbgleich(formId, r) {
    var k = konten[formId];
    var m = modelle[formId] && modelle[formId].modell;
    var z = zustaende()[formId];
    if (!k || !m || !z || !r || (!r.neu && !r.verworfen)) return;
    if (k.geaendert) {
      kontoSpeichern(formId, m, z, 'abgleich');
      return;
    }
    if (k.ausUrl) return;
    var v = r.verworfen ? null : kontoVorgaben(r.stand);
    k.vorgaben = v;
    var neu = startZustand(m, {
      variantId: z.variantId,
      paket: v && v.paket ? v.paket : (m.vorausgewaehlt || standardPaket(m)),
      extras: v ? v.extras : {},
      anfrage: v ? v.anfrage : [],
      menge: z.menge
    });
    uebernehme(z, neu);
    aktualisiere(formId, 'konto');
    k.text = JSON.stringify(kontoStand(m, z, optionenAusDom(formId)));
    if (v) kontoVariante(formId, m, v);
  }

  // Stand in Spiegel und Konto: nur nach einer Nutzeraktion und nur, wenn er sich geaendert hat (abgleich/alt: immer)
  function kontoSpeichern(formId, m, z, grund) {
    var k = konten[formId];
    if (!k || !z) return;
    var immer = grund === 'abgleich' || grund === 'alt';
    if (!immer && !NUTZERGRUND[grund]) return;
    var s = kontoStand(m, z, optionenAusDom(formId));
    var t = JSON.stringify(s);
    if (!immer && t === k.text) return;
    k.text = t;
    k.geaendert = true;
    k.mv.speichern(k.werkzeug, s);
  }

  function initAlle() {
    alsListe(document.querySelectorAll('script[data-mv-konf-data]')).forEach(function (s) {
      var id = s.getAttribute('data-mv-konf-data');
      if (id) initFormular(id);
    });
  }

  // ---- Eingaben aus dem Zustand zurueckschreiben ----------------------------------------------

  function karteVon(input) {
    return input.closest('.mv-checkkarte, .mv-radiokarte, [data-mv-karte], label') || input.parentElement;
  }

  function attributSetzen(el, name, wert) {
    if (!el) return;
    if (wert === null) {
      if (el.hasAttribute(name)) el.removeAttribute(name);
    } else if (el.getAttribute(name) !== wert) {
      el.setAttribute(name, wert);
    }
  }

  // Fallback-Klasse is-active fuer Browser ohne :has (Design-System 6.5)
  function aktivMarkieren(input) {
    var karte = input.closest('.mv-radiokarte, .mv-checkkarte, .mv-chip');
    if (karte) karte.classList.toggle('is-active', !!input.checked);
  }

  function schreibeHinweis(input, karte, hinweis) {
    var ziel = karte || input.parentElement;
    if (!ziel) return;
    var el = ziel.querySelector('[data-mv-extra-hinweis]');
    if (!el) {
      if (!hinweis) return;
      el = document.createElement('span');
      el.className = 'mv-checkkarte__text';
      el.setAttribute('data-mv-extra-hinweis', '');
      hinweisZaehler += 1;
      el.id = 'mv-konf-hinweis-' + hinweisZaehler;
      (ziel.querySelector('.mv-checkkarte__inhalt') || ziel).appendChild(el);
      var beschrieben = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
      if (beschrieben.indexOf(el.id) === -1) {
        beschrieben.push(el.id);
        input.setAttribute('aria-describedby', beschrieben.join(' '));
      }
    }
    if (el.textContent !== hinweis) el.textContent = hinweis || '';
    el.hidden = !hinweis;
  }

  function schreibeEingaben(formId, m, z, r) {
    alle('input[name="mv-paket"]', formId).forEach(function (el) {
      var key = wertVon(el, 'data-mv-paket');
      var p = findePaket(m, key);
      el.checked = key === z.paket;
      if (p && !p.verfuegbar) {
        el.disabled = true;
        attributSetzen(karteVon(el), 'data-disabled', 'nicht-verfuegbar');
      }
      aktivMarkieren(el);
    });
    alle('input[name="mv-extra[]"]', formId).forEach(function (el) {
      var handle = wertVon(el, 'data-mv-extra');
      var regel = r[handle] || { status: 'nicht-verfuegbar', hinweis: TEXTE.nichtVerfuegbar };
      var frei = regel.status === 'frei';
      var imPaket = regel.status === 'im-paket';
      var karte = karteVon(el);
      el.disabled = !frei;
      el.checked = frei ? !!z.extras[handle] : imPaket;
      attributSetzen(el, 'data-disabled', frei ? null : regel.status);
      attributSetzen(karte, 'data-disabled', frei ? null : regel.status);
      attributSetzen(karte, 'data-im-paket', imPaket ? '' : null);
      // "Im Paket enthalten" zeigt die Statuszeile der Karte (.mv-checkkarte__status); nur ohne sie als Text
      var hatStatus = !!(karte && karte.querySelector('.mv-checkkarte__status, [data-mv-status-im-paket]'));
      schreibeHinweis(el, karte, frei || (imPaket && hatStatus) ? '' : regel.hinweis);
      aktivMarkieren(el);
    });
    alle('input[data-mv-anfrage-extra]', formId).forEach(function (el) {
      el.checked = z.anfrage.indexOf(wertVon(el, 'data-mv-anfrage-extra')) !== -1;
      aktivMarkieren(el);
    });
  }

  // ---- Ausgaben ---------------------------------------------------------------------------------

  function setzeText(el, t) {
    if (el.textContent !== t) el.textContent = t;
  }

  function renderePositionen(container, positionen) {
    var tag = /^(UL|OL)$/.test(container.tagName) ? 'li' : 'div';
    var fragment = document.createDocumentFragment();
    positionen.forEach(function (p) {
      var zeile = document.createElement(tag);
      zeile.className = 'mv-summe__position';
      zeile.setAttribute('data-mv-position', p.art);
      var name = document.createElement('span');
      name.textContent = (p.menge > 1 ? p.menge + NBSP + '\u00d7 ' : '') + p.titel;
      var wert = document.createElement('span');
      wert.className = 'mv-summe__position-wert';
      wert.textContent = formatGeld(p.gesamt) + ' ' + TEXTE.netto;
      zeile.appendChild(name);
      zeile.appendChild(wert);
      fragment.appendChild(zeile);
    });
    while (container.firstChild) container.removeChild(container.firstChild);
    container.appendChild(fragment);
  }

  function konfHinweise(formId, anlegen) {
    var liste2 = alle('[data-mv-konf-hinweis]', formId, 'data-mv-konf-hinweis');
    if (!liste2.length && anlegen) {
      var w = wurzeln(formId)[0];
      if (w) {
        var p = document.createElement('p');
        p.className = 'mv-hinweis';
        p.setAttribute('role', 'status');
        p.setAttribute('data-mv-konf-hinweis', '');
        w.appendChild(p);
        liste2 = [p];
      }
    }
    return liste2;
  }

  function zeigeKonfHinweis(formId, t) {
    konfHinweise(formId, !!t).forEach(function (el) {
      setzeText(el, t || '');
      el.hidden = !t;
    });
  }

  function kurzMarkieren(formId) {
    alle('.mv-summe', formId, 'data-mv-summe').forEach(function (el) {
      el.classList.add('is-aktualisiert');
      clearTimeout(el._mvAktualisiert);
      el._mvAktualisiert = setTimeout(function () { el.classList.remove('is-aktualisiert'); }, 700);
    });
  }

  function rendereAusgaben(formId, m, z, s, grund) {
    var konfiguration = konfigurationsText(m, z, s);
    var produkt = produktText(m, z);
    if (s.vollstaendig || z.variantId === null) {
      var netto = s.vollstaendig ? formatGeld(s.netto) : TEXTE.unbekannt;
      var brutto = s.vollstaendig ? formatBrutto(s.brutto) : TEXTE.unbekannt;
      alle('[data-mv-summe-netto]', formId, 'data-mv-summe-netto').forEach(function (el) { setzeText(el, netto); });
      alle('[data-mv-summe-brutto]', formId, 'data-mv-summe-brutto').forEach(function (el) { setzeText(el, brutto); });
      if (s.leasing !== null) {
        var rate = s.vollstaendig ? formatGeld(s.leasing) : TEXTE.unbekannt;
        alle('[data-mv-leasing-rate]', formId, 'data-mv-leasing-rate').forEach(function (el) { setzeText(el, rate); });
      }
      if (s.vollstaendig) alle('[data-mv-positionen]', formId, 'data-mv-positionen').forEach(function (el) { renderePositionen(el, s.positionen); });
    }
    alle('[data-mv-open-anfrage]', formId).forEach(function (el) {
      attributSetzen(el, 'data-konfiguration', konfiguration);
      attributSetzen(el, 'data-produkt', produkt);
    });
    var nurAnfrage = z.anfrage.length ? 'true' : 'false';
    wurzeln(formId).forEach(function (w) {
      attributSetzen(w, 'data-mv-nur-anfrage', nurAnfrage);
      attributSetzen(w, 'data-mv-paket-aktiv', z.paket || '');
    });
    alle('[data-mv-sticky]', formId, 'data-mv-sticky').forEach(function (el) { attributSetzen(el, 'data-mv-nur-anfrage', nurAnfrage); });
    zeigeKonfHinweis(formId, z.anfrage.length ? TEXTE.nurAnfrage : '');
    if (NUTZERGRUND[grund]) kurzMarkieren(formId);
  }

  function planeAnalyse(formId) {
    clearTimeout(analyseTimer[formId]);
    analyseTimer[formId] = setTimeout(function () {
      var eintrag = modelle[formId];
      var z = zustaende()[formId];
      if (!eintrag || !z) return;
      var daten = analyseDaten(eintrag.modell, z, summe(eintrag.modell, z));
      var signatur = JSON.stringify(daten);
      if (analyseZuletzt[formId] === signatur) return;
      analyseZuletzt[formId] = signatur;
      publish('konfiguration_change', daten);
    }, ANALYSE_MS);
  }

  function uebernehme(ziel, quelle) {
    ziel.variantId = quelle.variantId;
    ziel.paket = quelle.paket;
    ziel.extras = quelle.extras;
    ziel.anfrage = quelle.anfrage;
    ziel.menge = quelle.menge;
  }

  // Zentrale Neuberechnung: Zustand bereinigen, Eingaben zurueckschreiben, Ausgaben, Speicher, Event
  function aktualisiere(formId, grund) {
    var m = ladeModell(formId);
    var z = zustaende()[formId];
    if (!m || !z) return null;
    uebernehme(z, bereinige(m, z));
    var r = regeln(m, z);
    var s = summe(m, z);
    schreibeEingaben(formId, m, z, r);
    rendereAusgaben(formId, m, z, s, grund);
    if (konten[formId]) {
      kontoHinweis(formId);
      kontoSpeichern(formId, m, z, grund);
    } else speichere(m, z, formId);
    if (grund !== 'stumm') {
      try {
        sende(document, 'mv:konf:change', {
          formId: formId,
          state: kopie(z),
          summeNetto: s.netto,
          summeBrutto: s.brutto,
          leasingRate: s.leasing,
          konfiguration: konfigurationsText(m, z, s),
          grund: grund
        });
      } catch (e) { /* fremde Listener duerfen nicht stoeren */ }
      if (NUTZERGRUND[grund]) planeAnalyse(formId);
    }
    return s;
  }

  // ---- Lightbox ---------------------------------------------------------------------------------

  // Bevorzugt der Kaufbox-CTA (#mv-cta-angebot-pdp, mv-cta-anfrage.liquid), sonst ein Oeffner mit dem
  // Interesse des Anfrage-Extras (Standard "Kauf"); nie zuerst der Leasing-Link (Block 10 steht vor dem CTA)
  function oeffneAnfrage(formId, m, z) {
    var oeffner = alle('[data-mv-open-anfrage]', formId);
    var gewuenscht = 'Kauf';
    for (var i = 0; i < z.anfrage.length; i++) {
      var a = findeAnfrage(m, z.anfrage[i]);
      if (a && a.interesse) {
        gewuenscht = a.interesse;
        break;
      }
    }
    var ausserhalbLeiste = oeffner.filter(function (el) { return !el.closest('[data-mv-sticky]'); });
    var ziel = oeffner.filter(function (el) { return el.id === 'mv-cta-angebot-pdp'; })[0] ||
      ausserhalbLeiste.filter(function (el) { return (el.getAttribute('data-interesse') || '') === gewuenscht; })[0] ||
      oeffner.filter(function (el) { return (el.getAttribute('data-interesse') || '') === gewuenscht; })[0] ||
      ausserhalbLeiste[0] || oeffner[0];
    if (ziel) {
      ziel.click(); // die Lightbox (snippets/mv-anfrage-modal.liquid) oeffnet per Delegation
      return;
    }
    window.location.href = routenWurzel() + 'pages/contact?anfrage=1&interesse=Kauf&produkt=' + encodeURIComponent(produktText(m, z));
  }

  // ---- Warenkorb --------------------------------------------------------------------------------

  function neueKonfigId() {
    return 'k' + Date.now().toString(36) + Math.floor(Math.random() * 1679616).toString(36);
  }

  function submitKnoepfe(form, formId) {
    var knoepfe = alsListe(form.elements).filter(function (el) { return el.type === 'submit'; });
    alle('[data-mv-sticky-kaufen]', formId).forEach(function (el) {
      if (knoepfe.indexOf(el) === -1) knoepfe.push(el);
    });
    return knoepfe;
  }

  // Shopify liefert bei 422 eine lesbare description (z. B. Bestand); sonst eigener Text
  function fehlerText(antwort, json) {
    if (json && typeof json.description === 'string' && json.description) return json.description;
    return antwort ? TEXTE.fehler : TEXTE.netzwerk;
  }

  function meldeFehler(form, m, z, meldung, status, mitRefresh) {
    sende(form, 'cart:error', { error: maskiere(meldung) });
    if (mitRefresh) document.dispatchEvent(new CustomEvent('cart:refresh'));
    publish('konfiguration_fehler', {
      produkt: m.produkt.handle,
      variante: z.variantId ? String(z.variantId) : '',
      paket: z.paket || '',
      status: status || 0,
      fehler: String(meldung).slice(0, 150)
    });
  }

  async function legeInWarenkorb(form, formId) {
    if (laufend[formId]) return;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      if (typeof form.reportValidity === 'function') form.reportValidity();
      return;
    }
    var m = ladeModell(formId);
    var z = zustaende()[formId];
    var ausDomId = variantIdAusDom(formId); // Impacts Hidden-Input name="id" ist massgeblich
    if (ausDomId) z.variantId = ausDomId;
    z.menge = mengeAusDom(formId);
    var s = aktualisiere(formId, 'stumm');

    if (z.anfrage.length) {
      zeigeKonfHinweis(formId, TEXTE.nurAnfrage);
      oeffneAnfrage(formId, m, z);
      return;
    }
    var problem = pruefeBestellbar(m, z);
    if (problem) {
      meldeFehler(form, m, z, problem, 0, false);
      return;
    }

    var konfigId = neueKonfigId();
    var items = baueItems(m, z, konfigId);
    if (!sende(document, 'mv:konf:add', { formId: formId, state: kopie(z), items: items, konfig: konfigId }, true)) return;

    laufend[formId] = true;
    var knoepfe = submitKnoepfe(form, formId);
    knoepfe.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    try {
      var sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      var wurzel = routenWurzel();
      var body = { items: items, sections: sections.join(','), sections_url: wurzel + 'variants/' + items[0].id };

      var antwort = null;
      var json = {};
      try {
        antwort = await fetch(wurzel + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        });
        try {
          json = (await antwort.json()) || {};
        } catch (e1) {
          json = {};
        }
      } catch (e2) {
        antwort = null;
      }

      if (!antwort || !antwort.ok) {
        meldeFehler(form, m, z, fehlerText(antwort, json), antwort ? antwort.status : 0, true);
        return;
      }

      var daten = analyseDaten(m, z, s);
      daten.konfig = konfigId;
      daten.zeilen = items.length;
      var einst = themeEinstellungen();
      if (einst.cartType === 'page' || einst.pageType === 'cart') {
        publish('konfiguration_warenkorb', daten);
        window.location.href = wurzel + 'cart';
        return;
      }
      var cart;
      try {
        cart = await (await fetch(wurzel + 'cart.js')).json();
      } catch (e3) {
        publish('konfiguration_warenkorb', daten);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }
      cart.sections = json.sections;
      var zeilen = Object.prototype.hasOwnProperty.call(json, 'items') ? json.items : [json];
      sende(form, 'variant:add', { items: zeilen, cart: cart });
      sende(document.documentElement, 'cart:change', { baseEvent: 'variant:add', cart: cart });
      publish('konfiguration_warenkorb', daten);
      sende(document, 'mv:konf:added', { formId: formId, cart: cart, items: zeilen, konfig: konfigId });
    } catch (e4) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      laufend[formId] = false;
      knoepfe.forEach(function (b) { b.removeAttribute('aria-busy'); });
    }
  }

  // ---- Ereignisse (nur Delegation auf document) -------------------------------------------------

  function aufAenderung(e) {
    var el = e.target;
    if (!el || !el.matches) return;
    var grund = null;
    if (el.matches('input[name="mv-paket"]')) grund = 'paket';
    else if (el.matches('input[name="mv-extra[]"]')) grund = 'extra';
    else if (el.matches('input[data-mv-anfrage-extra]')) grund = 'anfrage';
    else if (el.matches('input[name="quantity"]')) grund = 'menge';
    if (!grund) return;
    var formId = grund === 'menge'
      ? (el.getAttribute('form') || (el.form && el.form.getAttribute('id')))
      : (formIdVon(el) || el.getAttribute('form') || einzigerKonfigurator());
    if (!hatDaten(formId)) return;
    var z = initFormular(formId);
    if (!z) return;
    var m = modelle[formId].modell;
    if (konten[formId]) konten[formId].variante = null; // A-2b: eine Wahl auf der Seite ersetzt die gespeicherte Ausfuehrung
    if (grund === 'paket') {
      if (!el.checked) return;
      z.paket = wertVon(el, 'data-mv-paket');
    } else if (grund === 'extra') {
      var handle = wertVon(el, 'data-mv-extra');
      var extra = findeExtra(m, handle);
      if (el.checked) z.extras[handle] = extra ? extra.jeAutomat : ganzzahlMin1(el.getAttribute('data-mv-je-automat'));
      else delete z.extras[handle];
    } else if (grund === 'anfrage') {
      var key = wertVon(el, 'data-mv-anfrage-extra');
      var i = z.anfrage.indexOf(key);
      if (el.checked && i === -1) z.anfrage.push(key);
      if (!el.checked && i !== -1) z.anfrage.splice(i, 1);
    } else {
      var menge = mengeAusDom(formId);
      if (menge === z.menge) return;
      z.menge = menge;
    }
    aktualisiere(formId, grund);
  }

  document.addEventListener('change', aufAenderung);
  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[name="quantity"]')) aufAenderung(e);
  });

  // Impact: VariantPicker feuert variant:change (bubbles) NACH product:rerender; die liquid-Bloecke
  // sind dann schon ersetzt. detail.formId ist bei Impact das Hidden-Input (form.id), daher Formular
  // ueber event.target.
  document.addEventListener('variant:change', function (e) {
    var form = e.target;
    var formId = form && form.getAttribute ? form.getAttribute('id') : null;
    if (!hatDaten(formId)) return;
    geplant[formId] = false;
    var z = initFormular(formId);
    if (!z) return;
    var m = ladeModell(formId);
    var d = e.detail || {};
    var v = d.variant;
    if (v && v.id) {
      z.variantId = numId(v.id);
      var k = String(v.id);
      if (m && !m.varianten[k] && typeof v.price === 'number') {
        m.varianten[k] = { preis: Math.round(v.price), titel: ohneStandardTitel(v.title || v.public_title), verfuegbar: v.available !== false };
      }
    } else if (Object.prototype.hasOwnProperty.call(d, 'variant')) {
      z.variantId = null; // Kombination ohne Variante
    } else {
      var ausDomId = variantIdAusDom(formId);
      if (ausDomId) z.variantId = ausDomId;
    }
    // A-2b: kam der Wechsel aus dem gespeicherten Stand (kontoVariante: gleiche Variante), gelten dessen Paket und Extras
    // fuer die neue Ausfuehrung (bereinige hatte variantengebundene Extras der alten verworfen); kein Speichern. Ein
    // anderer Wechsel ist eine Nutzeraktion und beendet das Wiederherstellen.
    var k = konten[formId];
    var ausStand = !!k && k.variante !== null && String(z.variantId) === k.variante;
    if (k) k.variante = null;
    if (ausStand) {
      if (k.vorgaben && !k.geaendert && !k.ausUrl) {
        if (k.vorgaben.paket) z.paket = k.vorgaben.paket;
        z.extras = k.vorgaben.extras;
        z.anfrage = k.vorgaben.anfrage.slice();
      }
      aktualisiere(formId, 'konto');
      k.text = JSON.stringify(kontoStand(m, z, optionenAusDom(formId)));
      return;
    }
    aktualisiere(formId, 'variante');
  });

  // product:rerender bubbelt nicht und kommt VOR dem Austausch: Capture-Listener, Abgleich als Mikrotask
  document.addEventListener('product:rerender', function (e) {
    var form = e.target;
    var formId = form && form.getAttribute ? form.getAttribute('id') : null;
    if (!hatDaten(formId)) return;
    geplant[formId] = true;
    Promise.resolve().then(function () {
      if (!geplant[formId]) return;
      geplant[formId] = false;
      if (initFormular(formId)) aktualisiere(formId, 'rerender');
    });
  }, true);

  // Capture-Phase auf document laeuft vor Impacts ProductForm-Listener am Formular
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var formId = form.getAttribute('id');
    if (!hatDaten(formId) || !initFormular(formId)) return; // ohne Daten-JSON bleibt alles bei Impact
    e.preventDefault();
    e.stopImmediatePropagation();
    legeInWarenkorb(form, formId).catch(function (fehler) { warne('Warenkorb: ' + (fehler && fehler.message)); });
  }, true);

  window.addEventListener('pageshow', function (e) {
    if (!e || !e.persisted) return;
    Object.keys(bereit).forEach(function (id) { aktualisiere(id, 'stumm'); });
  });

  MV.konfigurator = {
    version: VERSION,
    logik: logik,
    zustand: function (formId) { return zustaende()[formId] || null; },
    aktualisieren: function (formId) { return aktualisiere(formId, 'stumm'); },
    initialisieren: initAlle
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { nachBuendel(initAlle); });
  else nachBuendel(initAlle);
})();
